// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const naganadel: PokeData = {
  "id": 804,
  "name": "naganadel",
  "height": 36,
  "weight": 1500,
  "base_experience": 243,
  "types": [
    PokeType.POISON,
    PokeType.DRAGON
  ],
  "api_moves": [
    "fury-attack",
    "growl",
    "acid",
    "peck",
    "toxic",
    "charm",
    "helping-hand",
    "air-cutter",
    "gastro-acid",
    "poison-jab",
    "air-slash",
    "dragon-pulse",
    "dragon-rush",
    "nasty-plot",
    "venoshock",
    "fell-stinger",
    "venom-drench"
  ],
  "moves": [
    "growl",
    "acid",
    "peck",
    "poison-jab",
    "air-slash",
    "dragon-pulse",
    "dragon-rush",
    "venom-drench",
    "poison-powder",
    "dragon-breath",
    "poison-gas",
    "purify",
    "stun-spore"
  ],
  "evolution_chain": {
    "id": 424,
    "item": null,
    "species": [
      {
        "name": "poipole",
        "order": 803,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "naganadel",
        "order": 804,
        "types": [
          PokeType.POISON,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 803,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "dragon-pulse"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 91,
    "speed": 151,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
